var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-page-paddings" }, [
    _c(
      "div",
      { staticClass: "container container-medium" },
      [
        _c("Heading", {
          attrs: { title: _vm.$t("legislative_info"), alignment: "text-left" },
        }),
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.scrollToElement("rovinieta")
              },
            },
          },
          [
            _vm._v(
              _vm._s(_vm.$t("legislative_info")) +
                " " +
                _vm._s(_vm.capitalize(_vm.$tc("vignetteWord", 1)))
            ),
          ]
        ),
        _vm._v(" | "),
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.scrollToElement("peaj")
              },
            },
          },
          [
            _vm._v(
              _vm._s(_vm.$t("legislative_info")) +
                " " +
                _vm._s(_vm.capitalize(_vm.$tc("tollWord", 0)))
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "default-content reading",
            attrs: { id: "rovinieta" },
          },
          [
            _c("p", { staticClass: "heading-medium" }, [
              _vm._v(_vm._s(_vm.capitalize(_vm.$tc("vignetteWord", 1)))),
            ]),
            _vm.locale == "ro"
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      " Ordonanţa nr. 15 din 24 ianuarie 2002 privind aplicarea tarifului de utilizare şi a tarifului de trecere pe reţeaua de drumuri naţionale din România "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/ordonanta-nr-15-din-24-ianuarie-2002.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " LEGE nr. 221 din 17 noiembrie 2016 pentru modificarea şi completarea Ordonanţei Guvernului nr. 15/2002 privind aplicarea tarifului de utilizare şi a tarifului de trecere pe reţeaua de drumuri naţionale din România "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/lege-nr-221-din-17-noiembrie-2016.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " ORDIN nr. 1463 din 21 septembrie 2018 privind aprobarea Normelor metodologice pentru aplicarea de către Compania Naţională de Administrare a Infrastructurii Rutiere - S.A. a tarifului de utilizare şi a tarifului de trecere "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/ordin-nr-1463-din-21-septembrie-2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " NORME METODOLOGICE din 21 septembrie 2018 pentru aplicarea de către Compania Naţională de Administrare a Infrastructurii Rutiere - S.A. a tarifului de utilizare şi a tarifului de trecere "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/norme-metodologice-din-21-septembrie-2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Formular cerere corectii erori materiale "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/cerere_corectie_rovinieta_16.11.2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Formulare cerere schimbare numar inmatriculare "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/Formular_cerere_schimbare_numar.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Formular cerere restituire tarif de utilizare "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/cerere_corectie_rovinieta_16.11.2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Cerere restituire tarif de utilizare a drumurilor nationale pentru radiere din circulatie "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(_vm.url + "pdfs/radiere.pdf")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Cerere pentru restituirea tarifului de utilizare aferent diferentei de categorie "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/diferenta_categorie.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Cerere restituire tarif de utilizare a drumurilor nationale pentru plata dubla "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(_vm.url + "pdfs/plata_dubla.pdf")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Cerere restituire tarif de utilizare a drumurilor nationale pentru plata dubla in cazul instrainarii "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/lege-nr-221-din-17-noiembrie-2016.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                ])
              : _c("div", [
                  _c("p", [
                    _vm._v(
                      " Ordinance no. 15 of January 24, 2002 on the application of the use tariff and the toll on the Romanian national road network "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/ordonanta-nr-15-din-24-ianuarie-2002.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " LAW no. 221 of November 17, 2016 for the amendment and completion of the Government Ordinance no. 15/2002 on the application of the use tariff and the toll on the Romanian national road network "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/lege-nr-221-din-17-noiembrie-2016.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " ORDER no. 1463 of September 21, 2018 regarding the approval of the Methodological Norms for the application by the CNAIR of the use tariff and the toll "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/ordin-nr-1463-din-21-septembrie-2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " METHODOLOGICAL NORMS from September 21, 2018 for the application by CNAIR CNAIR of the use tariff and the toll "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/norme-metodologice-din-21-septembrie-2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Material error correction request form "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/cerere_corectie_rovinieta_16.11.2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Registration number change application forms "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/Formular_cerere_schimbare_numar.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Usage rate refund application form "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/cerere_corectie_rovinieta_16.11.2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Application for reimbursement of the tariff for the use of national roads for non-registration "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(_vm.url + "pdfs/radiere.pdf")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Request for refund of usage fee for category difference "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/diferenta_categorie.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Refund application for use of national roads for double payment "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(_vm.url + "pdfs/plata_dubla.pdf")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Application for refund of the use of national roads for double payment in case of selling "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/plata_dubla_instrainare.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Ordinance no. 41 from April 8, 2022 "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/ordin-nr-365-din-6-aprilie-2022"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "default-content reading", attrs: { id: "peaj" } },
          [
            _c("p", { staticClass: "heading-medium" }, [
              _vm._v(_vm._s(_vm.capitalize(_vm.$tc("tollWord", 0)))),
            ]),
            _vm.locale == "ro"
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      " Ordonanţa nr. 15 din 24 ianuarie 2002 privind aplicarea tarifului de utilizare şi a tarifului de trecere pe reţeaua de drumuri naţionale din România "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/ordonanta-nr-15-din-24-ianuarie-2002.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " LEGE nr. 221 din 17 noiembrie 2016 pentru modificarea şi completarea Ordonanţei Guvernului nr. 15/2002 privind aplicarea tarifului de utilizare şi a tarifului de trecere pe reţeaua de drumuri naţionale din România "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/lege-nr-221-din-17-noiembrie-2016.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " ORDIN nr. 1463 din 21 septembrie 2018 privind aprobarea Normelor metodologice pentru aplicarea de către Compania Naţională de Administrare a Infrastructurii Rutiere - S.A. a tarifului de utilizare şi a tarifului de trecere "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/ordin-nr-1463-din-21-septembrie-2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " NORME METODOLOGICE din 21 septembrie 2018 pentru aplicarea de către Compania Naţională de Administrare a Infrastructurii Rutiere - S.A. a tarifului de utilizare şi a tarifului de trecere "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/norme-metodologice-din-21-septembrie-2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Formular cerere corectii erori materiale "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/cerere-corectie-peaj-16.11.2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Formular cerere scutire - peaj Fetești "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/Cerere-de-acordare-a-scutirii-pentru-peaj-Fetesti_0.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Formular cerere restituire peaj diferente categorie "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/diferenta-categorie-peaj.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Formular cerere restituire peaj număr eronat "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/numar-eronat-peaj.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Formular cerere restituire peaj radiere circulație "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/radiere-peaj.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                ])
              : _c("div", [
                  _c("p", [
                    _vm._v(
                      " Ordinance no. 15 of January 24, 2002 on the application of the use tariff and the toll on the Romanian national road network "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/ordonanta-nr-15-din-24-ianuarie-2002.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " LAW no. 221 of November 17, 2016 for the amendment and completion of the Government Ordinance no. 15/2002 on the application of the use tariff and the toll on the Romanian national road network "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/lege-nr-221-din-17-noiembrie-2016.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " ORDER no. 1463 of September 21, 2018 regarding the approval of the Methodological Norms for the application by the CNAIR of the use tariff and the toll "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/ordin-nr-1463-din-21-septembrie-2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " METHODOLOGICAL NORMS from September 21, 2018 for the application by CNAIR CNAIR of the use tariff and the toll "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/norme-metodologice-din-21-septembrie-2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Material error correction request form "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/cerere-corectie-peaj-16.11.2018.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Exemption request form - Fetești toll "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url +
                                "pdfs/Cerere-de-acordare-a-scutirii-pentru-peaj-Fetesti_0.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Toll refund request form for categories differences "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/diferenta-categorie-peaj.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Wrong number toll refund request form "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/numar-eronat-peaj.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                  _c("p", [
                    _vm._v(" Traffic erasure toll refund application form "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openUrl(
                              _vm.url + "pdfs/radiere-peaj.pdf"
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                    ),
                  ]),
                ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }